// Dropbox links are stored in three shapes across the sections: a plain URL (operative
// reports), { name, link } (patient files) or { nom, lien } (echocardiography).

const fileNameOf = (url, index) => {
  const last = String(url).split('?')[0].split('/').pop() || '';
  try {
    return decodeURIComponent(last) || `Document ${index + 1}`;
  } catch (error) {
    return last || `Document ${index + 1}`;
  }
};

export const normalizeLinks = (links) =>
  (Array.isArray(links) ? links : [])
    .map((entry, index) => {
      if (typeof entry === 'string') return { link: entry, name: fileNameOf(entry, index) };
      if (entry && typeof entry === 'object') {
        const link = entry.link || entry.lien || entry.url || '';
        return { link, name: entry.name || entry.nom || fileNameOf(link, index) };
      }
      return null;
    })
    .filter((entry) => entry && entry.link);
